// Use environment variable if available (for production builds), otherwise use relative path (for dev proxy)
const getApiBaseUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL
  if (envUrl) {
    // Remove trailing slash if present
    return envUrl.replace(/\/$/, '')
  }
  return '/api'
}

export async function apiFetch(endpoint: string, options: RequestInit = {}) {
  const baseUrl = getApiBaseUrl()
  // Ensure endpoint starts with / if baseUrl is absolute, or keep as is for relative
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
  const url = `${baseUrl}${normalizedEndpoint}`

  const defaultHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  // Get auth token from localStorage if available
  const token = localStorage.getItem('auth_token')
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`
  }

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  }

  try {
    const response = await fetch(url, config)

    if (!response.ok) {
      if (response.status === 401) {
        // Clear auth token and redirect to login
        localStorage.removeItem('auth_token')
        window.location.href = '/login'
        throw new Error('Authentication failed')
      }
      // Return response even for errors so caller can check status
      // This allows 404s to be handled gracefully
      return response
    }

    return response
  } catch (error) {
    console.error('API request failed:', error)
    throw error
  }
}

export async function apiGet(endpoint: string) {
  return apiFetch(endpoint)
}

export async function apiPost(endpoint: string, data: any) {
  return apiFetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function apiPut(endpoint: string, data: any) {
  return apiFetch(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

export async function apiPatch(endpoint: string, data: any) {
  return apiFetch(endpoint, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
}

export async function apiDelete(endpoint: string) {
  return apiFetch(endpoint, {
    method: 'DELETE',
  })
}

